import { ClipboardCheck, Gauge, Camera, Lock } from "lucide-react";
import { Section } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { AuthImage } from "@/components/Photo";

export const InspectionView = ({ doc }) => (
  <div className="space-y-5">
    {doc.status === "finalisee" && <p data-testid="inspection-locked-notice" className="flex items-center gap-2 rounded-lg border border-border bg-background/60 p-3 text-sm"><Lock className="h-4 w-4 text-amber-400" /> Inspection finalisée : résultats et preuves conservés, non modifiables.</p>}
    {doc.status === "brouillon" && <p className="rounded-lg border border-sky-500/40 bg-sky-950/40 p-3 text-sm">Inspection en cours par {doc.user_name} (lecture seule).</p>}
    {doc.result === "non_conforme" && <p data-testid="inspection-blocked-notice" role="alert" className="rounded-lg border-2 border-red-500 bg-red-950/60 p-3 text-sm font-semibold text-red-100">Anomalie critique : l'équipement a été bloqué.</p>}
    <Section title="Points de contrôle" icon={ClipboardCheck} testId="inspection-view-items">
      <ol className="space-y-3">
        {doc.items.map((it, idx) => (
          <li key={it.item_id} data-testid={`view-item-${idx}`} className="rounded-lg border border-border p-3">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-medium"><span className="mr-2 font-data text-amber-400">{idx + 1}.</span>{it.label}</p>
              <div className="flex gap-2">
                {it.state === "conforme" && <StatusBadge status="conforme" />}
                {it.state === "anomalie" && <StatusBadge status={it.criticality || "mineure"} />}
                {!it.state && <span className="text-xs text-muted-foreground">Non renseigné</span>}
              </div>
            </div>
            {it.state === "anomalie" && (
              <div className="mt-3 flex gap-3">
                {it.photo_id && <AuthImage fileId={it.photo_id} alt="Photo anomalie" className="h-24 w-24 shrink-0 rounded-lg" testId={`view-item-${idx}-photo`} />}
                <p className="whitespace-pre-wrap text-sm">{it.comment}</p>
              </div>
            )}
          </li>
        ))}
      </ol>
    </Section>
    {doc.has_meter && (
      <Section title="Compteur" icon={Gauge} testId="inspection-view-meter">
        <p className="font-data text-lg" data-testid="view-meter-value">{doc.meter_value ?? "—"} {doc.meter_unit}</p>
        <p className="text-sm text-muted-foreground">Relevé précédent : {doc.previous_meter_value ?? "aucun"}</p>
        {doc.meter_justification && <p className="mt-2 text-sm">Justification : {doc.meter_justification}</p>}
        {doc.meter_photo_id && <AuthImage fileId={doc.meter_photo_id} alt="Compteur" className="mt-3 h-28 w-28 rounded-lg" />}
      </Section>
    )}
    {doc.photo_views.length > 0 && (
      <Section title="Photos de prise en charge" icon={Camera}>
        <div className="flex flex-wrap gap-4">
          {doc.photo_views.map((v) => (
            <div key={v.id} className="text-center text-xs">
              {doc.view_photos[v.id] ? <AuthImage fileId={doc.view_photos[v.id]} alt={v.label} className="h-28 w-28 rounded-lg" /> : <div className="flex h-28 w-28 items-center justify-center rounded-lg bg-muted text-muted-foreground">Non fournie</div>}
              <p className="mt-1">{v.label}</p>
            </div>
          ))}
        </div>
      </Section>
    )}
  </div>
);
